/* eslint import/no-unresolved: "off", import/extensions: "off" */

import '../stylesheets/iframe';

const { body } = document;
const { referer } = body.dataset;

const getLocation = (href) => {
  const l = document.createElement('a');
  l.href = href;
  return l;
};

const refererLocation = getLocation(referer);

const postNativeAppMessage = (payload) => {
  if (window.webkit && window.webkit.messageHandlers.dndIframeMessaging) {
    window.webkit.messageHandlers.dndIframeMessaging.postMessage(payload); // iOS message handler detected
  }

  if (window.appInterface) {
    window.appInterface.postMessage(JSON.stringify(payload)); // Android message handler detected
  }
};

const sendWindowSize = () => {
  const payload = { contentHeight: Math.max(body.scrollHeight, body.offsetHeight), type: 'autofit' };
  window.top.postMessage(payload, '*');
  postNativeAppMessage(payload);
};

window.addEventListener('message', ({ origin, data }) => {
  if (origin.includes(refererLocation.origin)) {
    if (data.type === 'colorMode') {
      const isDark = data.mode === 'dark';
      body.classList.add(isDark ? 'dark' : 'light');
      body.classList.remove(isDark ? 'light' : 'dark');
    }
  }
}, false);

window.addEventListener('resize', sendWindowSize);
window.onload = sendWindowSize;
